// Types
import { DataTotalInfo } from '@/types';

// Icons
import { GroupUserIcon } from '@shared/icons/GroupUserIcon';
import { ClockIcon } from '@shared/icons/ClockIcon';
import FileIcon from '@shared/icons/FileIcon';
export const LABEL_LAST_LOGIN = 'Your last login attempt at';
export const LABEL_TOLTAL_USERS_ADMIN = 'Total Users';
export const DATA_TOTAL_INFO_ADMIN: DataTotalInfo[] = [{
  id: '1',
  label: LABEL_TOLTAL_USERS_ADMIN,
  icon: <GroupUserIcon className="text-white" />
}, {
  id: '2',
  label: 'Total Resumes',
  icon: <FileIcon className="text-white" />
}, {
  id: '3',
  label: 'Last Login',
  icon: <ClockIcon className="text-white" />
}];
export const DATA_TOTAL_INFO_USER: DataTotalInfo[] = [{
  id: '1',
  label: LABEL_LAST_LOGIN,
  icon: <ClockIcon className="text-white" />
}, {
  id: '2',
  label: 'Your resume last updated at',
  icon: <FileIcon className="text-white" />
}];